export default __webpack_public_path__ + "static/media/trackYourReading.b205b8f4.png";